export default __webpack_public_path__ + "static/media/spaceExplorer_spaceHelmet.855f8b5f.svg";